<template>
<v-list class="pa-0">
  <v-list-tile :key="data.mac">
    <v-list-tile-content :class="classDisconnected">
      <template v-if="data.hostname && data.hostname.length>0">
        <v-list-tile-title class="font-weight-bold">{{ data.hostname }}</v-list-tile-title>
        <v-list-tile-sub-title class="caption">{{ data.mac }}</v-list-tile-sub-title>
      </template>
      <template v-else>
        <v-list-tile-title class="font-weight-bold">{{ data.mac }}</v-list-tile-title>
        <v-list-tile-sub-title class="caption"><pre> </pre></v-list-tile-sub-title>
      </template>
    </v-list-tile-content>
  </v-list-tile>
</v-list>
</template>

<script>
export default {
  name: 'GatewayItemHeader',
  props: ['data', 'isDisconnected'],
  computed: {
    classDisconnected() {
      return {
        'red--text': this.isDisconnected
      };
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/gateway/GatewayItemHeader.vue